export const highLine={
    title:"HIGHLINE",
    gift:"מתנת בית חכם",
    fill:"אנא מלא ושלח את פרטייך על מנת שנוכל\n.לחזור אלייך בהקדם למימוש ההטבה",
    submitMessage:"!פרטייך הועברו בהצלחה\n.ייצרו איתך קשר בהקדם",
    errorMessage:"משהו השתבש\n. אנא נסה מאוחר יותר."
}